/**
 * initNotificationsBar({
 *   pusher: window.PSH,                 // existing Pusher instance (recommended)
 *   channels: ['auction', 'auction-123','private-customer-ABC'],  // subscribe here
 *   persist: true,                      // keep in localStorage
 *   storageKey: 'auction:notifs',       // localStorage key
 * })
 * If you don't pass `pusher`, the module expects window.PSH to exist.
 */
(function() {
	const DEFAULT_EVENTS = [
		'auction_created', 'auction_extended', 'auction_bid_update',
		'auction_ended', 'auction_won', 'auction_lost', 'customer_bid_data',
		'bid-updated', 'bid_placed', 'save_after'
	];

	const ICONS = {
		auction_created: bell(),
		auction_extended: clock(),
		auction_bid_update: bolt(),
		bid_updated: bolt(),
		bid_confirmed: bolt(),
		auction_ended: flag(),
		auction_won: trophy(),
		auction_lost: xmark(),
		customer_bid_data: warn(),
		default: bell()
	};

	function bell() {
		return `<svg viewBox="0 0 24 24" fill="none"><path d="M15 17h5l-1.4-1.4A2 2 0 0 1 18 14.172V11a6 6 0 1 0-12 0v3.172a2 2 0 0 1-.6 1.428L4 17h5m6 0v1a3 3 0 1 1-6 0v-1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
	}

	function clock() {
		return `<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="M12 7v5l3 3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
	}

	function bolt() {
		return `<svg viewBox="0 0 24 24" fill="none"><path d="M13 3L4 14h7l-1 7 9-11h-7l1-7z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>`;
	}

	function flag() {
		return `<svg viewBox="0 0 24 24" fill="none"><path d="M5 3v18M6 3h11l-2 4 2 4H6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
	}

	function trophy() {
		return `<svg viewBox="0 0 24 24" fill="none"><path d="M8 21h8M9 17h6v2H9zM7 3h10v2a5 5 0 0 1-10 0V3zM5 5H3a3 3 0 0 0 3 3M19 5h2a3 3 0 0 1-3 3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
	}

	function xmark() {
		return `<svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>`;
	}

	function warn() {
		return `<svg viewBox="0 0 24 24" fill="none"><path d="M12 9v4M12 17h.01M10.3 4.7l-7 12.6A2 2 0 0 0 5.1 21h13.8a2 2 0 0 0 1.8-3.7l-7-12.6a2 2 0 0 0-3.4 0z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
	}

	function nowISO() {
		return new Date().toISOString();
	}

	function fmtTime(iso) {
		try {
			const d = new Date(iso);
			// Timezone label from sta-time.js; plain local time if it never loaded.
			return window.staFormatStamp ? window.staFormatStamp(d) : d.toLocaleString();
		} catch {
			return iso;
		}
	}

	function renderUI(root) {
		root.innerHTML = `
	  <div class="an-alerts" id="an-alerts"></div>
      <div class="an-notif-root">
        <div class="an-panel" id="an-panel">
          <div class="an-panel-header">
            <span>Notifications</span>
            <div class="an-panel-actions">
              <span class="an-chip" id="an-mark-all">Mark all read</span>
              <span class="an-chip" id="an-clear-all">Clear</span>
            </div>
          </div>
          <ul class="an-list" id="an-list"></ul>
        </div>
        <button class="an-bell" id="an-bell" aria-label="Notifications">
          <span class="an-badge" id="an-badge" style="display:none;">0</span>
          ${bell()}
        </button>
      </div>
    `;
	}

	function initNotificationsBar(opts = {}) {
		const pusher = opts.pusher || window.PSH;
		if (!pusher) {
			console.warn('[AN] Pusher instance not found');
			return;
		}

		// Build UI
		let mount = document.getElementById('an-root');
		if (!mount) {
			mount = document.createElement('div');
			mount.id = 'an-root';
			document.body.appendChild(mount);
		}
		renderUI(mount);

		const els = {
			bell: document.getElementById('an-bell'),
			badge: document.getElementById('an-badge'),
			panel: document.getElementById('an-panel'),
			list: document.getElementById('an-list'),
			markAll: document.getElementById('an-mark-all'),
			clearAll: document.getElementById('an-clear-all'),
		};
		// ---- ALERTS ----
		function esc(v){ return String(v ?? '').replace(/[&<>"']/g, m=>({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[m])); }

		// Choose alert color by event
		function variantFor(event, payload){
			switch(event){
				case 'auction_won': return 'success';
				case 'bid_confirmed': return 'success';
				case 'auction_lost': return 'danger';
				case 'auction_extended': return 'warning';
				case 'customer_bid_data': return payload?.outbid ? 'danger' : 'success';
				default: return 'info';
			}
		}

		// Show Bootstrap-like alert with payload fields when available
		function showAlert({ variant = 'info', title = '', body = '', payload = {} }) {
		const el = document.createElement('div');
		el.className = `an-alert an-${variant}`;

		// pull common bits safely
		const esc = (v) => String(v ?? '').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
		const auctionId = String(payload.auction_id ?? payload.id ?? '').trim();
		const productUrl = payload.product_url ?? '';
		const imageUrl = payload.product_image_url ?? '';

		// title: force uppercase to mimic design
		const titleText = (title || 'New bid placed').toUpperCase();

		// The lot is what the shopper recognises; the auction number is the
		// fallback for events that arrive without a product name.
		const metaText = payload.product_name || body || (auctionId ? `Auction #${auctionId}` : '');

		// Body + close button, with the lot's picture in front when we have one
		if (imageUrl) el.classList.add('an-alert--with-image');
		el.innerHTML = `
			${imageUrl ? `<img src="${esc(imageUrl)}" alt="" loading="lazy">` : ''}
			<div class="an-alert-body">
			<div class="an-alert-title">${esc(titleText)}</div>
			<div class="an-alert-meta">${esc(metaText)}</div>
			${productUrl ? `<a class="an-alert-link" href="${esc(productUrl)}">View lot</a>` : ''}
			</div>
			<button class="an-btn an-close" aria-label="Close">×</button>
		`;

		el.querySelector('.an-close').addEventListener('click', () => {
			el.classList.remove('show');
			setTimeout(() => el.remove(), 180);
		});

		document.getElementById('an-alerts').appendChild(el);
		requestAnimationFrame(() => el.classList.add('show'));
		setTimeout(() => {
			el.classList.remove('show');
			setTimeout(() => el.remove(), 180);
		}, 10000);
		}


		// State
		const STORAGE = opts.storageKey || 'auction:notifs';
		let items = opts.persist ? (JSON.parse(localStorage.getItem(STORAGE) || '[]')) : [];
		let unread = items.filter(n => !n.read).length;

		function save() {
			if (opts.persist) localStorage.setItem(STORAGE, JSON.stringify(items.slice(-200)));
			updateBadge();
			renderList();
		}

		function updateBadge() {
			if (unread > 0) {
				els.badge.style.display = 'inline-block';
				els.badge.textContent = String(unread);
			} else {
				els.badge.style.display = 'none';
			}
		}

		function iconFor(event) {
			return ICONS[event] || ICONS.default;
		}

		function pushItem({
			channel,
			event,
			title,
			body,
			payload
		}) {
			const entry = {
				id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
				channel,
				event,
				title,
				body,
				payload,
				createdAt: nowISO(),
				read: false
			};
			items.push(entry);
			unread++;
			save();
		}

		function renderList() {
			if (!items.length) {
				els.list.innerHTML = `<li class="an-empty">No notifications yet</li>`;
				return;
			}
			els.list.innerHTML = items.slice().reverse().map(n => `
        <li class="an-item" data-id="${n.id}">
          <div class="an-icon">${iconFor(n.event)}</div>
          <div>
            <p class="an-title">${n.title || n.body || n.event}</p>
            <p class="an-sub">${n.channel ? `${n.channel} • ` : ''}${fmtTime(n.createdAt)}</p>
          </div>
        </li>
      `).join('');
		}

		// Open/close
        els.bell.addEventListener('click', () => {
            els.panel.classList.toggle('open');
        });

		els.markAll.addEventListener('click', () => {
            unread = 0;
            items = items.map(n => ({ ...n, read: true }));
            save();
        });

		els.clearAll.addEventListener('click', () => {
			items = [];
			unread = 0;
			save();
		});
        // CLOSE PANEL WHEN CLICKING OUTSIDE
        document.addEventListener('click', (e) => {
            const isOpen = els.panel.classList.contains('open');
            const clickedInsidePanel = els.panel.contains(e.target);
            const clickedBell = els.bell.contains(e.target);
            if (isOpen && !clickedInsidePanel && !clickedBell) {
                els.panel.classList.remove('open');
            }
        });

		// Render initial
		updateBadge();
		renderList();

		// Subscribe to channels (module covers ALL you pass in)
		const knownEvents = new Set(DEFAULT_EVENTS.concat(opts.extraEvents || []));
		// Every channel bound here, so a channel asked for twice — once from the
		// live-auction list, again by the lot page — is not bound twice and does
		// not deliver each event twice.
		const watchedChannels = new Set();

		function watchChannel(name) {
			if (!name || watchedChannels.has(name)) return;
			watchedChannels.add(name);

			const ch = pusher.channel(name) || pusher.subscribe(name);
			// Bind all known events on this channel, and include channel name
			knownEvents.forEach(evt => {
				ch.bind(evt, (payload) => handleEvent({
					channel: name,
					event: evt,
					payload
				}));
			});
		}

		(opts.channels || []).forEach(watchChannel);

		// Catch unknown events globally (channel not provided by the SDK here)
		pusher.bind_global((eventName, payload) => {
			if (eventName.startsWith('pusher:')) return; // ignore internals
			// If we already handled it via channel-specific bind, skip (avoid dupes)
			if (knownEvents.has(eventName)) return;
			handleEvent({
				channel: undefined,
				event: eventName,
				payload
			});
		});

		// A dropped socket loses every event sent while it was down, and Pusher
		// does not replay them. When it comes back, the views on the page refetch
		// what they show instead of waiting for the next bid to correct them.
		let connectedOnce = pusher.connection.state === 'connected';
		pusher.connection.bind('state_change', ({ current }) => {
			if (current !== 'connected') return;
			if (connectedOnce) requestLiveResync('reconnect');
			connectedOnce = true;
		});

		// Pull a usable auction id from common payload shapes
		function extractAuctionId(obj) {
		if (!obj || typeof obj !== 'object') return null;
		const cands = [
			obj.auction_id,           // snake_case
			obj.auctionId,            // camelCase
			obj.id,                   // plain id
			obj.auction?.id,          // nested auction.id
			obj.data?.id              // JSON:API-ish
		];
		for (const x of cands) {
			if (x === undefined || x === null) continue;
			const s = String(x).trim();
			if (s) return s;
		}
		return null;
		}


		// Event → Title/body mapper
		var priceEl     = document.querySelector('[data-sta-auction-live-price]');
		
		function formatLike(el, amount) {
			if (window.staFormatMoneyPlain) return window.staFormatMoneyPlain(amount);
			return '$' + amount + ' CAD';
		}

		function setMoneyPrice(el, amount) {
			if (!el) return;
			if (window.staSetMoneyEl) window.staSetMoneyEl(el, amount);
			else el.textContent = formatLike(el, amount);
		}

		function auctionEndIso(payload) {
			return payload?.end_date || payload?.new_date || null;
		}

		// Lot events carry no auction id in some payloads, but the channel they
		// arrived on always names one.
		function channelAuctionId(channel) {
			const match = /^auction-(\d+)$/.exec(String(channel || ''));
			return match ? match[1] : '';
		}

		function eventAuctionId(channel, payload) {
			return extractAuctionId(payload) || channelAuctionId(channel);
		}

		function pageAuctionId() {
			try {
				return window.staResolveAuctionId ? String(window.staResolveAuctionId() || '') : '';
			} catch (e) {
				return '';
			}
		}

		/** Events raised about the shopper rather than about a lot. */
		const PERSONAL_EVENTS = new Set([
			'customer_bid_data', 'auction_won', 'auction_lost', 'bid_confirmed'
		]);

		/**
		 * Whether an event is worth interrupting the shopper for.
		 *
		 * The page subscribes to every live auction, so lot events arrive in
		 * bulk — without this, a busy sale would bury the notifications that
		 * matter under a toast for every bid in the house. Personal events always
		 * pass; lot events only for the lot on screen or one the shopper is in.
		 */
		function isNoteworthy(event, channel, payload) {
			if (PERSONAL_EVENTS.has(event)) return true;
			if (String(channel || '').indexOf('customer-') === 0) return true;

			const auctionId = eventAuctionId(channel, payload);
			if (!auctionId) return false;
			if (auctionId === pageAuctionId()) return true;

			return Boolean(window.staBidStatus && window.staBidStatus.get(auctionId));
		}

		/**
		 * Mirrors a personal event onto the "Winning" / "Outbid" badges shown
		 * wherever the lot appears — cards, PDP, account rows. Only the
		 * customer-<id> channel carries these, so the state can only ever be the
		 * signed-in shopper's own.
		 */
		function syncBidStatus(event, payload) {
			if (!window.staSetBidStatus) return;

			const auctionId = extractAuctionId(payload);
			if (!auctionId) return;

			switch (event) {
				case 'customer_bid_data':
					window.staSetBidStatus(auctionId, payload?.outbid ? 'outbid' : 'winning');
					break;
				case 'auction_won':
					window.staSetBidStatus(auctionId, 'won');
					break;
				case 'auction_lost':
					window.staSetBidStatus(auctionId, 'lost');
					break;
				default:
					break;
			}
		}

		function handleEvent({ channel, event, payload }) {
			let title = '';
			let body  = '';

			syncBidStatus(event, payload);

			// Views that keep their own copy of a lot's price or end time — the
			// account page's bid rows — follow along through this.
			document.dispatchEvent(new CustomEvent('sta:auction-event', {
				detail: { event, channel, auctionId: eventAuctionId(channel, payload), payload }
			}));

			// The price, bid count, and countdown below belong to the lot on
			// screen. Every other live auction is on this socket too, and until
			// this check existed any of them could repaint this page's PDP.
			const forThisPage =
				!!pageAuctionId() && eventAuctionId(channel, payload) === pageAuctionId();

			switch (event) {
				case 'auction_created':
					title = payload?.title || 'New Auction';
					body  = payload?.product_name || payload?.title || 'A new auction is live';
					break;

			case 'auction_extended':
				title = 'Auction extended';
				var _extEndIso = auctionEndIso(payload);
				body  = (payload?.product_name || 'Auction') + (_extEndIso ? ` → ${fmtTime(_extEndIso)}` : '');
				var _extEndSpec = forThisPage
					&& document.querySelector('.product-price__date .sta-product-spec .sta-product-spec__body');
				if (_extEndSpec && _extEndIso) {
					_extEndSpec.setAttribute('data-end-iso', _extEndIso);
				}
				// The countdown moves at once; the refetch brings the "Bidding Ends"
				// date with it, and covers a payload that arrived without a date.
				if (forThisPage && window.staRepaintAuctionPdp) window.staRepaintAuctionPdp(pageAuctionId());
				break;

			case 'auction_bid_update':
			case 'bid-updated':
			case 'bid_updated':
			case 'bid_placed':
				title = 'New bid placed';
				body  = `Current price: ${payload?.current_price ?? '—'} · Bids: ${payload?.bids_count ?? payload?.bid_count ?? '—'}`;
				if (forThisPage) {
					var _bidsN = parseInt(payload?.bids_count ?? payload?.bid_count, 10);
					var _bidCountEl = document.querySelector('.product-price__bids-body .product-price__bids-count');
					if (_bidCountEl && Number.isFinite(_bidsN)) _bidCountEl.textContent = `${_bidsN} ${_bidsN === 1 ? 'Bid' : 'Bids'}`;
					if (priceEl && payload?.current_price != null) setMoneyPrice(priceEl, payload.current_price);
					// Flip "Starting bid:" → "Last bid price:" live, matching the load-time paint.
					var _bidPriceLabel = document.querySelector('[data-sta-auction-price-label]');
					if (_bidPriceLabel && Number.isFinite(_bidsN) && _bidsN > 0) _bidPriceLabel.textContent = 'Last bid price:';
					// Reconcile from the auction record: the bid payload carries no end
					// date or bidder standing, and a late bid extends the lot in a
					// separate event that this one may beat or that may be lost.
					if (window.staRepaintAuctionPdp) window.staRepaintAuctionPdp(pageAuctionId());
					var _bidEndSpec = document.querySelector('.product-price__date .sta-product-spec .sta-product-spec__body');
					var _bidEndIso = auctionEndIso(payload);
					if (_bidEndSpec && _bidEndIso) _bidEndSpec.setAttribute('data-end-iso', _bidEndIso);
				}
				break;

			case 'save_after':
				title = 'Auction updated';
				body  = payload?.message || '';
				if (forThisPage) {
					var _saveEndSpec = document.querySelector('.product-price__date .sta-product-spec .sta-product-spec__body');
					var _saveEndIso = auctionEndIso(payload);
					if (_saveEndSpec && _saveEndIso) _saveEndSpec.setAttribute('data-end-iso', _saveEndIso);
					if (priceEl && payload?.current_price != null) setMoneyPrice(priceEl, payload.current_price);
				}
				break;

				case 'customer_bid_data':
					// Personal channel only: this is the shopper's own standing on
					// the lot, which is why it can say "you" outright.
					title = payload?.outbid ? 'You have been outbid' : 'You are winning';
					body  = payload?.product_name || '';
					// The badge is already set above; the refetch brings the max bid.
					if (forThisPage && window.staRepaintAuctionPdp) window.staRepaintAuctionPdp(pageAuctionId());
					break;

				case 'auction_ended':
					title = 'Auction ended';
					body  = `Final price: ${payload?.auction_price ?? '—'}`;
					break;

				case 'auction_won':
					title = 'You won! 🎉';
					body  = payload?.product_name || 'Check out to complete purchase';
					break;

				case 'auction_lost':
					title = 'Auction lost';
					body  = payload?.product_name || '';
					break;

				case 'bid_confirmed':
					// Raised locally by place-bids.js the moment the API accepts a
					// bid, so the shopper gets the same receipt in the bell as every
					// other event rather than only the inline message on the PDP.
					title = payload?.raised ? 'Maximum bid updated' : 'Bid placed';
					body  = payload?.product_name || '';
					break;

				default:
					title = event;
					body  = (payload && typeof payload === 'object') ? JSON.stringify(payload) : String(payload);
			}

			if (!isNoteworthy(event, channel, payload)) return;

			// NEW: alert for every event
			showAlert({ variant: variantFor(event, payload), title, body, payload });

			// and keep it in the bell's list
			pushItem({ channel, event, title, body, payload });
		}


		// return small API if you need it later
		const api = {
			push: (entry) => pushItem(entry),
			/**
			 * Raises an event locally, through the same path a Pusher message
			 * takes. Used for the receipts the server has no reason to broadcast
			 * — chiefly "Bid placed", which only the bidder should ever see.
			 */
			notify: (event, payload = {}) => handleEvent({ channel: 'local', event, payload }),
			markAllRead: () => {
				unread = 0;
				items = items.map(n => ({
					...n,
					read: true
				}));
				save();
			},
			clear: () => {
				items = [];
				unread = 0;
				save();
			},
			subscribe: (name, events = []) => {
				const ch = pusher.channel(name) || pusher.subscribe(name);
				const set = new Set(events.length ? events : DEFAULT_EVENTS);
				set.forEach(evt => ch.bind(evt, (payload) => handleEvent({
					channel: name,
					event: evt,
					payload
				})));
			},
			watchAuction: (auctionId) => watchChannel(`auction-${auctionId}`)
		};

		// Reachable from anywhere in the theme (place-bids.js raises its receipt
		// through it) without having to thread the return value around.
		window.staNotifications = api;

		pendingAuctionWatches.forEach(api.watchAuction);
		pendingAuctionWatches.clear();

		return api;
	}

	/**
	 * Lots asked for before the socket was set up. The bar only starts once the
	 * live-auction list has loaded, and the lot page and account page usually
	 * know their auction ids before that.
	 */
	const pendingAuctionWatches = new Set();

	/**
	 * Receives bid, outbid and extension events for one lot. Safe to call at
	 * any time, any number of times: the channel is only bound once. Without it
	 * a page only hears about the lots in the first page of /api/auctions.
	 */
	window.staWatchAuction = function(auctionId) {
		const id = String(auctionId ?? '').trim();
		if (!id) return;
		if (window.staNotifications && window.staNotifications.watchAuction) {
			window.staNotifications.watchAuction(id);
		} else {
			pendingAuctionWatches.add(id);
		}
	};

	/**
	 * Asks every live view on the page to refetch what it shows. Raised when the
	 * socket reconnects and when the tab comes back into view: a background tab
	 * can be throttled or lose its socket, and either way it misses events.
	 */
	function requestLiveResync(reason) {
		document.dispatchEvent(new CustomEvent('sta:live-resync', { detail: { reason } }));
	}

	document.addEventListener('visibilitychange', () => {
		if (document.visibilityState === 'visible') requestLiveResync('visible');
	});

	// expose
	window.initNotificationsBar = initNotificationsBar;
})();